export const CATCHMENT_TOUR_STORAGE_KEY = 'studentCatchment:mapTour:v1';

export const CATCHMENT_TOUR_STEPS = [
  {
    id: 'student-pins',
    title: 'Student addresses',
    body: 'View your student addresses on the map. Pins are green unless you tagged them as new or existing — then new students are blue and existing students stay green.',
    spotlight: 'map',
    cardAlign: 'top-left',
  },
  {
    id: 'drive-rings',
    title: 'Distance tiers',
    body: 'Median drive time plus the share of students in each 5-, 10-, and 15-minute ring. Click a ring to highlight those students on the map.',
    spotlight: 'drive-metrics',
    cardAlign: 'bottom-left',
  },
  {
    id: 'basemap',
    title: 'Map style',
    body: 'Switch Streets, Satellite, or Detailed streets.',
    spotlight: 'basemap',
    cardAlign: 'top-right',
  },
  {
    id: 'custom-places',
    title: 'Custom places',
    body: 'Add addresses for bus stops, preschools, or other places you care about.',
    spotlight: 'custom-places',
    cardAlign: 'top-left',
    expandControls: true,
  },
  {
    id: 'nearby-schools',
    title: 'Nearby schools',
    body: 'Turn nearby schools on or off. Matching campuses, neighborhoods, and districts appear in the table below the map.',
    spotlight: ['nearby-schools', 'results-table'],
    cardAlign: 'top-left',
    expandControls: true,
  },
];

export const tourSpotlightIds = (step) => {
  if (Array.isArray(step?.spotlight)) return step.spotlight.filter(Boolean);
  if (step?.spotlight) return [step.spotlight];
  return [];
};

const readFlag = (key) => {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch (_err) {
    return false;
  }
};

const writeFlag = (key) => {
  try {
    window.localStorage.setItem(key, '1');
  } catch (_err) {
    // Private browsing or disabled storage should not break the tool.
  }
};

export const readCatchmentTourDismissed = () => readFlag(CATCHMENT_TOUR_STORAGE_KEY);
export const writeCatchmentTourDismissed = () => writeFlag(CATCHMENT_TOUR_STORAGE_KEY);

export const shouldShowCatchmentTour = ({ dismissed, replaying, hasResults }) =>
  Boolean(hasResults && (!dismissed || replaying));
